/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { isBlank } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import { HelpModalComponentArgs } from 'cio/components/help-modal';

const FEATURES_FEEDBACK_OPTIONAL = ['parcel_editor_on'];

interface DisableExperimentalFeatureFormArgs extends HelpModalComponentArgs {
  analyticsData?: Record<string, string>;
}

export default class DisableExperimentalFeatureForm extends Component<DisableExperimentalFeatureFormArgs> {
  @tracked feedback = '';

  feedbackImage = new URL('cio/assets/images/feedback.png', import.meta.url).toString();

  get isSubmitButtonDisabled() {
    if (FEATURES_FEEDBACK_OPTIONAL.includes(this.args.analyticsData?.feature ?? '')) {
      return false;
    }

    return isBlank(this.feedback);
  }

  @action
  onSubmit(e: Event) {
    e.preventDefault();

    let skipSendingFeedback = isBlank(this.feedback);

    this.args.onSubmit(
      {
        criticism: `Why do you want to disable ${this.args.analyticsData?.feature}?`,
        praise: this.feedback,
      },
      false,
      skipSendingFeedback,
    );
  }
}
